/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';

import MfaVerification from '../views/MfaVerification';

import SessionService from '../../../apiServices/SessionService';
import { authToken } from '../../../utilities/LocalStorage';
import AppUtils from '../../../utilities/AppUtils';
import RouteNames from '../../appAuthorized/RouteNames';
import { loginWithPendingIntent } from './pendingIntendedGroup';

class MfaLogin extends React.Component {

  constructor(props) {
    super(props);

    this.submitMfaCode = this.submitMfaCode.bind(this);
    this.clearError = this.clearError.bind(this);
    this.cancelMfa = this.cancelMfa.bind(this);

    this.state = {
      errorMessage: null,
      token: authToken.get(),
      mfaCodeIsGoodEnough: false,
    };
  }

  submitMfaCode(mfaCode) {
    if (mfaCode.length > 5) {
      SessionService.mfaLogin(mfaCode, this.props.duration, (apiError) => {
        if (apiError) {
          this.setState({
            errorMessage: <FormattedMessage id={apiError.messageKey()} />,
          });
        } else {
          const sessionData = AppUtils.extractDataFromAuthToken(authToken.get());
          loginWithPendingIntent(sessionData.user, this.props.submitUserUpdate);
        }
      });
    } else {
      this.setState({
        errorMessage: <FormattedMessage id="error.2fa-code-validator.message" />,
      });
    }
  }

  cancelMfa() {
    AppUtils.logout({}, () => {
      this.props.goBack();
    });
  }

  clearError() {
    this.setState({
      errorMessage: null,
    });
  }

  render() {
    if (this.props.isMissingMfaToken) { return <Redirect to={RouteNames.login()} />; }

    return (
      <MfaVerification
        token={this.state.token}
        errorMessage={this.state.errorMessage}
        submitMfaCode={this.submitMfaCode}
        cancelMfa={this.cancelMfa}
        clearError={this.clearError}
      />
    );
  }
}
MfaLogin.propTypes = {
  goBack: PropTypes.func,
  duration: PropTypes.string,
  isMissingMfaToken: PropTypes.bool,
  submitUserUpdate: PropTypes.func,
};

export default MfaLogin;
